import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { LoadingPageBody } from '@framework/ui/components/loader/LoadingPageBody.tsx';
import type React from 'react';
import { DossierCard } from '../components/DossierCard.tsx';
import { useDossier } from '../detail/hooks/useDossier.ts';

export interface DossierCardWrapperProps {
  submission?: RichiestaDTO | null;
  children?: React.ReactNode;
}

/**
 * Wrapper
 */
export default function DossierCardWrapper(props: DossierCardWrapperProps) {
  const { submission, children } = props;
  const dossierData = useDossier(submission?.idIstanzaProcedimentoPratica);

  // In caso di errore, non andiamo in loading altrimenti le chiamate alla GET/dossier nei nodi figli
  // che vanno a loro volta in errore (e quindi non sono salvate in cache) rimettono in loading anche
  // la useDossier qui. In quel caso, i children sono smontati, per poi essere rimontati, ritrovando un
  // errore che riporta in loading. Questo produce un loop di loading infinito.
  // Per evitare questo, se c'è un errore, non mostriamo il loading. Non viene smontato il componente children
  // e il flusso continua senza loop.
  if (dossierData.isLoading && !dossierData.error) {
    return <LoadingPageBody transparent />;
  }

  return (
    <DossierCard procedureDossier={dossierData.procedure ?? undefined}>
      {children}
    </DossierCard>
  );
}
